<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>REST &amp; AJAX</div>
				<h2 waHeading="l" waText>&#64;NgRestClient &mdash; Typed Angular REST Services</h2>
				<p waBody="m" waColorText="quiet" waText>One annotation per endpoint. Signals, polling, caching, auth &mdash; no handwritten TypeScript.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_145"></markdown>
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>&#64;NgRestClient</h3>
							<p waBody="m" waColorText="quiet" waText>Annotate a Java class with &#64;NgRestClient to generate an &#64;Injectable Angular service. Specify the URL, HTTP method, response type, and behaviour flags &mdash; the TypeScript code is produced at build time by the Angular Maven Plugin.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Signal-Based State</h3>
							<p waBody="m" waColorText="quiet" waText>Every generated service exposes data&#40;&#41;, loading&#40;&#41;, error&#40;&#41;, and success&#40;&#41; as Angular WritableSignals. Components read them reactively &mdash; no manual subscribe/unsubscribe.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Polling &amp; Caching</h3>
							<p waBody="m" waColorText="quiet" waText>Enable pollingEnabled with a configurable interval to re-fetch automatically. Enable cachingEnabled with a TTL to skip the network call when data is still fresh.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Deduplication &amp; Retry</h3>
							<p waBody="m" waColorText="quiet" waText>In-flight request deduplication prevents duplicate HTTP calls. Configurable retryCount and retryDelayMs handle transient failures automatically.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Authentication</h3>
							<p waBody="m" waColorText="quiet" waText>Built-in auth support &mdash; Bearer, Basic, or Custom header. Set authType and authTokenField to inject the token into every request.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Headers &amp; Query Params</h3>
							<p waBody="m" waColorText="quiet" waText>&#64;NgRestClientHeader and &#64;NgRestClientQueryParam add static headers and query parameters to every request from the generated service.</p>
						</div>
					</wa-card>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Simple GET client</div>
					<markdown [data]="mdContent_146" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>POST with caching, retry, and deduplication</div>
					<markdown [data]="mdContent_147" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Polling with deep merge</div>
					<markdown [data]="mdContent_148" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Bearer auth with custom headers and query params</div>
					<markdown [data]="mdContent_149" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>